<template>
  <!--  视频解析 -->
  <el-container class="videoAnalysis">
    <el-tabs v-model="activeName" class="aa" @tab-click="handleClick">
      <!-- <el-tab-pane label="地图" name="first">
        <video-analysis-map ref="mapRef"></video-analysis-map>
      </el-tab-pane> -->
      <el-tab-pane label="离线视频解析" name="second">
        <off-line-video :dict="sourceStatus"></off-line-video>
      </el-tab-pane>
      <el-tab-pane label="在线录像解析" name="third">
        <on-line-video :dict="sourceStatus"></on-line-video>
      </el-tab-pane>
      <el-tab-pane label="实时视频流解析" name="fourth">
        <real-time-video :dict="sourceStatus"></real-time-video>
      </el-tab-pane>
      <el-tab-pane label="实时图片流解析" name="five">
        <real-time-picture :dict="sourceStatus"></real-time-picture>
      </el-tab-pane>
    </el-tabs>
  </el-container>
</template>
<script>
import { defineComponent, reactive, toRefs, nextTick, ref } from "vue";
import onLineVideo from "./components/onLineVideo.vue";
import realTimeVideo from "./components/realTimeVideo.vue";
import offLineVideo from "@/views/smartApplication/videoAnalysis/components/offLineVideo.vue";
import realTimePicture from "./components/realTimePicture.vue";
import videoAnalysisMap from "./components/videoAnalysisMap.vue";
import { queryRealVideoTree } from "@/api/videoControl/videoApi.js";
import { getDict } from "@/api/constant";
export default defineComponent({
  name: "videoAnalysis",
  components: {
    videoAnalysisMap,
    onLineVideo,
    realTimeVideo,
    offLineVideo,
    realTimePicture,
  },
  props: {},
  setup(props) {
    const state = reactive({
      activeName: "second",
      videoData: [],
      sourceStatus: [],
    });
    const refData = toRefs(state);
    const mapRef = ref(null);
    const getDictAxio = async () => {
      const res = await getDict("file_upload_status");
      state.sourceStatus = res.dict;
    };
    getDictAxio();
    const handleClick = (tab, event) => {
      console.log(tab, event);
    };
    // 获取区域树中摄像头数据
    const queryRealVideoTreeAsync = async () => {
      const res = await queryRealVideoTree();
      state.videoData = res.cameraBaseDtls;
      pointInfoArray(res.cameraBaseDtls);
    };
    // 添加接口中数据点位
    const pointInfoArray = (list) => {
      const array = list.filter((item, index) => {
        if (item.longitude && item.latitude) {
          return item;
        }
      });
      const newList = array.map((element, index) => {
        const pointInfo = {
          name: "",
          item: element,
          id: 1,
          type: 1,
          showType: 2,
          poiType: 3409,
          location: [],
          click: (e) => {
            nextTick(() => {
              state.mapDataItem = element;
            });
          },
        };
        pointInfo.id = index + 1;
        // pointInfo.poiType = element.type;
        pointInfo.location[0] = parseFloat(element.longitude);
        pointInfo.location[1] = parseFloat(element.latitude);
        return pointInfo;
      });
      nextTick(() => {
        console.log(newList);
        mapRef.value && mapRef.value.loadMarker(newList);
      });
    };

    return {
      ...refData,
      handleClick,
      mapRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.videoAnalysis {
  .el-tabs {
    width: 100%;
  }
}
</style>
